import React, { useEffect, useState } from 'react';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';

const Rate_Master_Interface = () => {
  const [months, setMonths] = useState([]);
  const [years, setYears] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedYear, setSelectedYear] = useState('');
  const [rateEntries, setRateEntries] = useState([]);
  const [editableEntries, setEditableEntries] = useState([]);
  const [hasData, setHasData] = useState(true);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        setLoading(true);
        const [monthsRes, yearsRes, currentRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_URL}/api/rate-master/months`, { withCredentials: true }),
          axios.get(`${process.env.REACT_APP_URL}/api/rate-master/years`, { withCredentials: true }),
          axios.get(`${process.env.REACT_APP_URL}/api/rate-master/current-month-year`, { withCredentials: true })
        ]);

        const monthsData = monthsRes.data.map(month => ({
          value: month.month,
          label: month.name
        }));
        setMonths(monthsData);

        const yearsData = yearsRes.data.map(year => ({
          value: year,
          label: year.toString()
        }));
        setYears(yearsData);

        const currentData = currentRes.data;
        if (currentData && currentData.month && currentData.year) {
          setSelectedMonth(parseInt(currentData.month));
          setSelectedYear(parseInt(currentData.year));
        } else {
          const now = new Date();
          setSelectedMonth(now.getMonth() + 1);
          setSelectedYear(now.getFullYear());
        }
      } catch (error) {
        console.error('Error fetching initial data:', error);
  
        setMonths([
          { value: 1, label: "January" }, { value: 2, label: "February" },
          { value: 3, label: "March" }, { value: 4, label: "April" },
          { value: 5, label: "May" }, { value: 6, label: "June" },
          { value: 7, label: "July" }, { value: 8, label: "August" },
          { value: 9, label: "September" }, { value: 10, label: "October" },
          { value: 11, label: "November" }, { value: 12, label: "December" }
        ]);
        
        const currentYear = new Date().getFullYear();
        const yearsData = [currentYear-1, currentYear, currentYear+1, currentYear+2].map(year => ({
          value: year,
          label: year.toString()
        }));
        setYears(yearsData);
        
        const now = new Date();
        setSelectedMonth(now.getMonth() + 1);
        setSelectedYear(now.getFullYear());
      } finally {
        setLoading(false);
      }
    };

    fetchInitialData();
  }, []);
  useEffect(() => {
    if (selectedMonth && selectedYear) {
      setLoading(true);
      axios.get(`${process.env.REACT_APP_URL}/api/rate-master/entries`, {
        params: {
          alotMonth: selectedMonth,
          alotYear: selectedYear
        },
        withCredentials: true
      })
      .then(response => {
        if (Array.isArray(response.data)) {
          setRateEntries(response.data);
          setHasData(response.data.length > 0);
        } else {
          setRateEntries([]);
          setHasData(false);
        }
      })
      .catch(err => {
        console.error("Fetch error:", err);
        setRateEntries([]);
        setHasData(false);
      })
      .finally(() => {
        setLoading(false);
      });
    }
  }, [selectedMonth, selectedYear]);

  const handleEdit = () => {
    setEditableEntries(rateEntries.map(e => ({ ...e })));
  };

  const handleChange = (index, field, value) => {
    const updated = [...editableEntries];
    if (["entitle", "dealerPrice", "beneficiaryPrice"].includes(field)) {
      const normalized = value.replace(',', '.');
      updated[index][field] = normalized === "" ? "" : parseFloat(normalized);
    } else if (field === "freezeStatus") {
      updated[index][field] = parseInt(value, 10);
    }
    setEditableEntries(updated);
  };

  const handleSave = async () => {
    let updatedCount = 0;

    const byScheme = editableEntries.reduce((acc, e) => {
      (acc[e.schemeName] = acc[e.schemeName] || []).push(e);
      return acc;
    }, {});

    for (let scheme in byScheme) {
      const list = byScheme[scheme];
      if (list[0].schemeType === 'N' && (scheme === 'AAY' || scheme === 'PHH')) {
        const expected = scheme === 'AAY' ? 35 : 5;
        const target = ['Wheat', 'Rice', 'FRice', 'Atta', 'Ragi', 'Jower'];
        const sum = list
          .filter(e => target.includes(e.commodityName))
          .reduce((s, e) => s + (e.entitle || 0), 0);
        if (sum !== expected) {
          alert(`Sum of entitle for ${scheme} must be ${expected} (is ${sum}).`);
          
          setEditableEntries(rateEntries.map(e => ({ ...e })));
          return;
        }
      }
    }

    for (let i = 0; i < editableEntries.length; i++) {
      const updated = editableEntries[i];
      const original = rateEntries[i];

      const hasChanged =
        updated.entitle !== original.entitle ||
        updated.dealerPrice !== original.dealerPrice ||
        updated.beneficiaryPrice !== original.beneficiaryPrice ||
        updated.freezeStatus !== original.freezeStatus;

      if (!hasChanged) continue;
      if (original.freezeStatus === 1 && updated.freezeStatus !== 1) {
        continue;
      }

      try {
        const res = await axios.post(`${process.env.REACT_APP_URL}/api/rate-master/update`, updated, {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true
        });
        if (res.status === 200) updatedCount++;
      } catch (err) {
        console.error('Save error:', err);
      }
    }

    if (updatedCount > 0) {
      const resp = await axios.get(`${process.env.REACT_APP_URL}/api/rate-master/entries`, {
        params: {
          alotMonth: selectedMonth,
          alotYear: selectedYear
        },
        withCredentials: true
      });
      setRateEntries(resp.data);
      setEditableEntries([]);
      alert('Entries updated successfully.');
    } else {
      alert('No entries were updated.');
    }
  };

  const inEdit = editableEntries.length > 0;
  const rows = inEdit ? editableEntries : rateEntries;

 if (loading) {
  return (
     <div style={{ textAlign: 'center', marginTop: '20px' }}>
       <CircularProgress/>
        </div>
  );
}


  return (
    <div className="wrapper row3" style={{ paddingBottom: '40px', overflow: 'hidden', position: 'relative' }}>
      <div id="container">
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
          <table width="35%">
            <thead>
              <tr className="tableheader">
                <th colSpan={4}>RATE MASTER ENTRY FORM</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Allotted Month:</td>
                <td>
                  <select 
                    value={selectedMonth} 
                    onChange={e => setSelectedMonth(e.target.value ? +e.target.value : '')} 
                    required
                  >
                    <option value="">--Select Month--</option>
                    {months.map(m => (
                      <option key={m.value} value={m.value}>{m.label}</option>
                    ))}
                  </select>
                </td>
                <td>Allotted Year:</td>
                <td>
                  <select 
                    value={selectedYear} 
                    onChange={e => setSelectedYear(e.target.value ? +e.target.value : '')} 
                    required
                  >
                    <option value="">--Select Year--</option>
                    {years.map(y => (
                      <option key={y.value} value={y.value}>{y.label}</option>
                    ))}
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {selectedMonth && selectedYear && !hasData && (
          <div style={{ textAlign: 'center', color: 'red', marginTop: '20px' }}>
            The selected month <strong>{months.find(m => m.value === selectedMonth)?.label}</strong> and year <strong>{selectedYear}</strong> does not have any data.
          </div>
        )}

        {selectedMonth && selectedYear && hasData && (
          <div style={{ marginTop: "20px", textAlign: "center" }}>
            <table border="1" style={{ margin: "0 auto", width: "60%" }}>
              <thead>
                <tr className="tableheader">
                  <th colSpan="6" >
                    Rate Master Entry Screen for the month of {months.find(m => m.value === selectedMonth)?.label}, {selectedYear}
                  </th>
                </tr>
                <tr className="tableheader">
                  <th>S.No</th>
                  <th>Scheme/Commodity</th>
                  <th>Entitle</th>
                  <th>RO Rate (KG/Ltr)<br />Dealer Price</th>
                  <th>Unit Rate (KG/Ltr)<br />Beneficiary Price</th>
                  <th>STATUS</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((e, i) => (
                  <tr key={i}>
                    <td style={{ textAlign: 'left' }}>{i + 1}</td>
                    <td style={{ textAlign: 'left' }}>{e.schemeName} / {e.commodityName}</td>
                    <td style={{ textAlign: 'left' }}>
                      {inEdit
                        ? <input
                            type="number"
                            step="0.01"
                            value={e.entitle ?? ""}
                            onChange={ev => handleChange(i, 'entitle', ev.target.value)}
                            disabled={e.freezeStatus === 1}
                          />
                        : e.entitle ?? '-'}
                    </td>
                    <td style={{ textAlign: 'left' }}>
                      {inEdit
                        ? <input
                            type="number"
                            step="0.01"
                            value={e.dealerPrice ?? ""}
                            onChange={ev => handleChange(i, 'dealerPrice', ev.target.value)}
                            disabled={e.freezeStatus === 1}
                          />
                        : e.dealerPrice != null ? Number(e.dealerPrice).toFixed(2) : '-'}
                    </td>
                    <td style={{ textAlign: 'left' }}>
                      {inEdit
                        ? <input
                            type="number"
                            step="0.01"
                            value={e.beneficiaryPrice ?? ""}
                            onChange={ev => handleChange(i, 'beneficiaryPrice', ev.target.value)}
                            disabled={e.freezeStatus === 1}
                          />
                        : e.beneficiaryPrice != null ? Number(e.beneficiaryPrice).toFixed(2) : '-'}
                    </td>
                    <td style={{ textAlign: 'left', textTransform: 'uppercase', color: 'green' }}>
                      {inEdit ? (
                        <select
                          value={e.freezeStatus}
                          onChange={ev => handleChange(i, 'freezeStatus', ev.target.value)}
                          disabled={e.freezeStatus === 1}
                        >
                          <option value={0}>ACTIVE</option>
                          <option value={1}>FREEZED</option>
                        </select>
                      ) : (
                        <span>{e.freezeStatus === 1 ? 'FREEZED' : 'ACTIVE'}</span>
                      )}
                    </td>
                  </tr>
                ))}
                {!inEdit && rateEntries.length > 0 && (
                  <tr>
                    <td colSpan="6" style={{ textAlign: "center" }}>
                      <button className="button button2" onClick={handleEdit}>Update</button>
                    </td>
                  </tr>
                )}
                {inEdit && (
                  <tr>
                    <td colSpan="6" style={{ textAlign: "center" }}>
                      <button className="button button2" onClick={handleSave}>Save</button>
                      <button className="button button2" style={{ marginLeft: 10 }} onClick={() => setEditableEntries([])}>Back</button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default Rate_Master_Interface;